/* eslint-disable */

'use strict'
const map = require('./google-map')

/**
 * build:
 * grunt webpack:googleMap
 *
 * test:
 * jasmine JASMINE_CONFIG_PATH=spec/support/jasmine-js.json
 *
 */

function eventHandler() {
    map.initialize()
}

if (window.document.readyState !== 'loading') {
    eventHandler()
} else {
    window.document.addEventListener('DOMContentLoaded', eventHandler)
}

//index.js replaced the <body onload="initialize()">
